import React from "react";
import PersonalData from "./PersonalData";
import Contact from "./Contact";
import ProfilePicture from "./ProfilePicture";
import { Button, Col, Row } from "reactstrap";
import { CustomerDto } from "../../store/models/CustomerDto";
import { Form } from "react-final-form";
import { ValidationErrors } from "final-form";
import { isFieldNeeded, validateMandatory } from "./Validation";
import { CustomerFormThunkProps } from "./CustomerFormContainer";
import { validateName } from "../registration/Validation";
import MembershipCancellationDialog from "./MembershipCancellationDialog";

export default class CustomerForm extends React.Component<CustomerFormThunkProps> {
  constructor(props: CustomerFormThunkProps) {
    super(props);
    this.state = { customer: props.customer };
  }

  validate = (customer: CustomerDto) => {
    const { customerFieldConfig } = this.props;
    const errors: ValidationErrors = {};

    validateMandatory(errors, customer, customerFieldConfig);
    validateName(errors, customer.firstName, customer.lastName);
    return errors;
  };

  removeRedundantProperties = (customer: CustomerDto) => {
    const { customerFieldConfig } = this.props;
    if (!isFieldNeeded("companyName", customerFieldConfig)) {
      delete customer.companyName;
    }
    if (!isFieldNeeded("vatId", customerFieldConfig)) {
      delete customer.vatId;
    }
    if (!isFieldNeeded("customerType", customerFieldConfig)) {
      delete customer.customerType;
    }
  };

  render() {
    const { customer, thunkUpdateCustomer } = this.props;

    return (
      <>
        <div className="customer-form">
          <Form
            onSubmit={(customer) => {
              this.removeRedundantProperties(customer);
              thunkUpdateCustomer(customer);
            }}
            initialValues={customer}
            validate={this.validate}
            render={({ handleSubmit }) => {
              const [membershipCancellationDialogVisible, setMembershipCancellationDialogVisible] =
                React.useState(false);
              return (
                <>
                  {membershipCancellationDialogVisible && (
                    <MembershipCancellationDialog
                      setMembershipCancellationDialogVisible={setMembershipCancellationDialogVisible}
                    />
                  )}
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-5">
                      <Col lg="3" md="6" className="d-flex align-items-center justify-content-center">
                        <ProfilePicture />
                      </Col>
                      <Col lg="9" md="6">
                        <PersonalData {...this.props} />
                      </Col>
                    </Row>
                    <Contact {...this.props} />
                    <Row>
                      <Col md={{ size: "auto" }}>
                        <Button type="submit">Speichern</Button>
                      </Col>
                      <Col md={{ size: "auto" }} className="ms-auto">
                        <Button
                          onClick={() => {
                            setMembershipCancellationDialogVisible(true);
                          }}
                        >
                          Kündigen
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </>
              );
            }}
          />
        </div>
      </>
    );
  }
}
